import React, { useEffect, useState } from "react";
import { db, ref, onValue } from "../firebase"; // Import the db object
import styles from "./styles/SessionHeader.module.css";
import { IonIcon } from "@ionic/react";
import { podiumOutline, stopwatchOutline } from "ionicons/icons";


const SessionHeader = ({ toggleSortOrder, sortBy }) => {
  const [currentLap, setCurrentLap] = useState("-");
  const [currentFlag, setCurrentFlag] = useState();
  const [totalLaps, setTotalLaps] = useState();
  const [sessionName, setSessionName] = useState();
  useEffect(() => {
    // Reference the Realtime Database path
    const dataRef = ref(db, "DemoDB/session/current_lap"); // Update path as needed

    // Subscribe to changes in the data
    const onDataChange = (snapshot) => {
      if (snapshot.exists()) {
        setCurrentLap(snapshot.val());
      } else {
        setCurrentLap(0);
      }
    };
    const unsubscribe = onValue(dataRef, onDataChange);
    // Clean up the subscription when the component unmounts
    return () => unsubscribe();
  }, []);
  useEffect(() => {
    const dataRef = ref(db, "DemoDB/session/flag_status"); // Update path as needed

    // Subscribe to changes in the data
    const onDataChange = (snapshot) => {
      if (snapshot.exists()) {
        setCurrentFlag(snapshot.val());
      } else {
        setCurrentFlag("");
      }
    };
    const unsubscribe = onValue(dataRef, onDataChange);
    // Clean up the subscription when the component unmounts
    return () => unsubscribe();
  });
  useEffect(() => {
    const dataRef = ref(db, "DemoDB/session/laps_to_go"); // Update path as needed

    // Subscribe to changes in the data
    const onDataChange = (snapshot) => {
      if (snapshot.exists()) {
        let total = Number(snapshot.val()) + Number(currentLap);
        setTotalLaps(total);
      }
    };
    const unsubscribe = onValue(dataRef, onDataChange);
    // Clean up the subscription when the component unmounts
    return () => unsubscribe();
  });
  useEffect(() => {
    const dataRef = ref(db, "DemoDB/session/name"); // Update path as needed

    // Subscribe to changes in the data
    const onDataChange = (snapshot) => {
      if (snapshot.exists()) {
        setSessionName(snapshot.val());
      } else {
        setSessionName("");
      }
    };
    const unsubscribe = onValue(dataRef, onDataChange);
    // Clean up the subscription when the component unmounts
    return () => unsubscribe();
  });
  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '90%' }}>
      <div className={styles.SessionHeaderTop}>
        <div className={styles.SessionHeaderTopLeft}>
          <div className={styles.live_capsule}>LIVE</div>
          <p className={styles.session_name}>{sessionName}</p>
        </div>
        <div className={styles.SessionHeaderTopRight}>
          <div className={styles.ToggleButton} onClick={() => toggleSortOrder()}>
            {sortBy === 'position' ?
              <IonIcon icon={podiumOutline} className={styles.ToggleButtonIcon} />
              :
              <IonIcon icon={stopwatchOutline} className={styles.ToggleButtonIcon} />
            }
          </div>
          <div className={styles.SessionHeaderStatusInfo}>
            {currentFlag == null ? <div className={styles.other_flag} /> : null}
            {currentFlag === "Green " ? (<div className={styles.green_flag} />) : null}
            {currentFlag === "Yellow" ? (<div className={styles.yellow_flag} />) : null}
            {currentFlag === "Red   " ? <div className={styles.red_flag} /> : null}
            {currentFlag === "Finish" ? (<div className={styles.checkered_flag} />) : null}
            <p className={styles.laps}>Lap {currentLap}/{totalLaps}</p>
          </div>
        </div>

      </div>
      <div className={styles.SessionHeaderBottom}>
        <div className={styles.position_box}><p>Pos</p></div>
        <div className={styles.competitor_box}><p>Competitor</p></div>
        <div className={styles.laps_box}><p>Laps</p> </div>
        <div className={styles.difference_box}><p>Diff</p></div>
        <div className={styles.last_lap_box}><p>Last</p></div>
        <div className={styles.best_time_box}><p>Best</p></div>
        <div className={styles.best_lap_box}><p>In</p></div>
      </div>
    </div>
  );
};

export default SessionHeader;
